<template>
  <div>
    <div :id="namespaceLivre">
      <b-col cols="12">
        <h2 :class="showDetails.livre ? 'rotate active' : 'no-rotate'">
          Commande par livre
          <i
            class="fas fa-chevron-left"
            @click="toggleLivre"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.livre"
        :id="'liste_stats_' + namespaceLivre"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableLivre"
          :name="namespaceLivre"
          :actions="getActions(namespaceLivre)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.livre"
          verbose-namespace="Commande par livre"
          @row-click="
            openDetails($event, namespaceLivre, 'ambassade', 'commande par livre')
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableLivre,
              namespaceLivre,
              'ambassade',
              'commande par livre'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespacePays">
      <b-col cols="12">
        <h2 :class="showDetails.pays ? 'rotate active' : 'no-rotate'">
          Commande par pays
          <i
            class="fas fa-chevron-left"
            @click="togglePays"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.pays"
        :id="'liste_stats_' + namespacePays"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTablePays"
          :name="namespacePays"
          :actions="getActions(namespacePays)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.pays"
          verbose-namespace="Commande par pays"
          @row-click="openDetails($event, namespacePays, 'ambassade', 'commande par pays')"
          @action-callback="
            dispatchAction(
              $event,
              refGenericTablePays,
              namespacePays,
              'ambassade',
              'commande par pays'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespaceAmbassade">
      <b-col cols="12">
        <h2 :class="showDetails.ambassade ? 'rotate active' : 'no-rotate'">
          Commande par ambassade
          <i
            class="fas fa-chevron-left"
            @click="toggleAmbassade"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.ambassade"
        :id="'liste_stats_' + namespaceAmbassade"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableAmbassade"
          :name="namespaceAmbassade"
          :actions="getActions(namespaceAmbassade)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.ambassade"
          verbose-namespace="Commande par ambassade"
          @row-click="
            openDetails(
              $event,
              namespaceAmbassade,
              'ambassade',
              'commande par ambassade'
            )
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableAmbassade,
              namespaceAmbassade,
              'ambassade',
              'commande par ambassade'
            )
          "
        />
      </b-col>
    </div>

    <StatsModal :generic-table-namespace="namespaceTab" />
  </div>
</template>

<script>
import MixinStats from "@/mixins/mixinStats";

export default {
  name: "ListeStatsAmbassades",
  mixins: [MixinStats],
  data() {
    return {
      refGenericTablePays: "tabPaysAmbassade",
      refGenericTableLivre: "tabLivreAmbassade",
      refGenericTableAmbassade: "tabAmbassadeAmbassade",

      namespacePays: "commandes_pays",
      namespaceLivre: "commandes_livre",
      namespaceAmbassade: "commandes_ambassade",

      showDetails: {
        livre: false,
        pays: false,
        ambassade: false,
      },

      extraFilters: {
        livre: {
          type: "ambassade",
          sous_type: "commande par livre",
        },
        pays: {
          type: "ambassade",
          sous_type: "commande par pays",
        },
        ambassade: {
          type: "ambassade",
          sous_type: "commande par ambassade",
        },
      },
    };
  },
  methods: {
    /**
     * Affiche/masque le tableau des commandes par livre et définit le namespace du tableau de recherche.
     * @public
     */
    toggleLivre() {
      this.showDetails.livre = !this.showDetails.livre;
      this.$store.commit("setNamespaceSearch", 0);
    },
    /**
     * Affiche/masque le tableau des commandes par pays et définit le namespace du tableau de recherche.
     * @public
     */
    togglePays() {
      this.showDetails.pays = !this.showDetails.pays;
      this.$store.commit("setNamespaceSearch", 1);
    },
    /**
     * Affiche/masque le tableau des commandes par ambassade et définit le namespace du tableau de recherche.
     * @public
     */
    toggleAmbassade() {
      this.showDetails.ambassade = !this.showDetails.ambassade;
      this.$store.commit("setNamespaceSearch", 2);
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/style/_stats.scss";
</style>
